function collectionHandleFromPath(pathname = window.location.pathname) {
  return pathname.match(/\/collections\/([^/?#]+)/)?.[1] || '';
}

function collectionHandleFromHref(href) {
  if (!href) return '';

  try {
    return new URL(href, window.location.origin).pathname.match(/\/collections\/([^/?#]+)/)?.[1] || '';
  } catch {
    return '';
  }
}

function handleMatchesNav(navHandle, currentHandle) {
  if (!navHandle || !currentHandle) return false;
  if (navHandle === currentHandle) return true;
  return currentHandle.startsWith(`${navHandle}-`);
}

function shouldOpenDetails(details, currentHandle) {
  for (const link of details.querySelectorAll('a[href*="/collections/"]')) {
    const navHandle = collectionHandleFromHref(link.getAttribute('href'));
    if (handleMatchesNav(navHandle, currentHandle)) return true;
  }

  return false;
}

function markCurrentLink(nav, currentHandle) {
  let bestLink = null;
  let bestScore = -1;

  nav.querySelectorAll('a[href*="/collections/"]').forEach((link) => {
    if (link.classList.contains('lwl-sidebar-nav__filter-link') || link.classList.contains('lwl-collection-quick-filters__chip--facet')) {
      return;
    }

    link.removeAttribute('aria-current');

    const navHandle = collectionHandleFromHref(link.getAttribute('href'));
    if (!handleMatchesNav(navHandle, currentHandle)) return;

    const score = navHandle === currentHandle ? 1000 + navHandle.length : navHandle.length;
    if (score > bestScore) {
      bestScore = score;
      bestLink = link;
    }
  });

  bestLink?.setAttribute('aria-current', 'page');
  return bestLink;
}

function metafieldFilterParamsFromUrl(url = window.location.href) {
  try {
    const currentUrl = new URL(url, window.location.origin);
    return [...currentUrl.searchParams.entries()].filter(([key]) => key.startsWith('filter.p.m.'));
  } catch {
    return [];
  }
}

function metafieldFilterParamsFromHref(href) {
  if (!href) return [];

  try {
    const linkUrl = new URL(href, window.location.origin);
    return [...linkUrl.searchParams.entries()].filter(([key]) => key.startsWith('filter.p.m.'));
  } catch {
    return [];
  }
}

function syncMetafieldFilterLinks(scope = document) {
  const activeParams = metafieldFilterParamsFromUrl();
  if (activeParams.length === 0) return;

  scope.querySelectorAll('.lwl-sidebar-nav__filter-link, .lwl-collection-quick-filters__chip--facet').forEach((link) => {
    const linkParams = metafieldFilterParamsFromHref(link.getAttribute('href'));
    const label = link.querySelector('span')?.textContent?.trim();

    const isActive =
      activeParams.some(([param, value]) =>
        linkParams.some(([linkParam, linkValue]) => linkParam === param && linkValue === value)
      ) ||
      activeParams.some(([param, value]) => {
        if (linkParams.length > 0) return false;
        return label != null && label.toUpperCase() === value.toUpperCase() && param.includes('connector_family');
      });

    if (!isActive) return;

    link.classList.add('is-active');
    link.setAttribute('aria-current', 'true');

    const offUrl = new URL(window.location.href);
    for (const [param, value] of activeParams) {
      if (linkParams.length > 0) {
        for (const [linkParam] of linkParams) {
          offUrl.searchParams.delete(linkParam);
        }
      } else if (label != null && label.toUpperCase() === value.toUpperCase()) {
        offUrl.searchParams.delete(param);
      }
    }
    link.setAttribute('href', `${offUrl.pathname}${offUrl.search}`);

    const details = link.closest('details.lwl-sidebar-nav__filter-group');
    if (details) details.open = true;
  });
}

function openActiveFilterGroups(nav) {
  nav.querySelectorAll('details.lwl-sidebar-nav__filter-group').forEach((details) => {
    const hasActiveFilter = details.querySelector(
      '.lwl-sidebar-nav__filter-link.is-active, .lwl-sidebar-nav__filter-link[aria-current="true"], .lwl-sidebar-nav__filter-link[aria-current="page"]'
    );

    if (hasActiveFilter) {
      details.open = true;
    }
  });
}

function initSidebarNav(nav) {
  if (!(nav instanceof HTMLElement)) return;

  const currentHandle = nav.dataset.currentCollection || collectionHandleFromPath();

  nav.querySelectorAll(':scope > .lwl-sidebar-nav__groups > .lwl-sidebar-nav__group > .lwl-sidebar-nav__details').forEach((details) => {
    details.open = true;
  });

  syncMetafieldFilterLinks(nav);
  openActiveFilterGroups(nav);

  if (currentHandle) {
    nav.querySelectorAll('details.lwl-sidebar-nav__filter-group').forEach((details) => {
      const hasActiveFilter = details.querySelector(
        '.lwl-sidebar-nav__filter-link.is-active, .lwl-sidebar-nav__filter-link[aria-current="true"], .lwl-sidebar-nav__filter-link[aria-current="page"]'
      );

      if (hasActiveFilter || shouldOpenDetails(details, currentHandle)) {
        details.open = true;
      }
    });

    nav.querySelectorAll('details.lwl-sidebar-nav__details').forEach((details) => {
      if (shouldOpenDetails(details, currentHandle)) {
        details.open = true;
      }
    });

    markCurrentLink(nav, currentHandle);
  }

  nav.querySelectorAll('.lwl-sidebar-nav__summary a').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });
}

function initAllSidebars() {
  document.querySelectorAll('.lwl-sidebar-nav').forEach(initSidebarNav);
  syncMetafieldFilterLinks(document);
  document.querySelectorAll('.lwl-sidebar-nav').forEach(openActiveFilterGroups);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSidebars);
} else {
  initAllSidebars();
}

document.addEventListener('shopify:section:load', initAllSidebars);
document.addEventListener('filter:update', initAllSidebars);
